import { TTSData } from "@/pages/DigitalHuman/util/tts-manage";
import { IAgentDataOutputs } from "@/services/api";
import { getStore } from "@/store";
import { getDigitalStore } from "@/store/digital";
import { LandmarkPoetryPlaceDetailType, PageMode } from "@/store/types";
import preloadAudio from "@/utils/preloadAudio";

export const getDefaultChatRequestBody = () => {
  // return {
  //   "inputs": {
  //     "query": "带我了解西湖边的书法泰斗马一浮"
  //   },
  //   "response_mode": "streaming",
  //   "app_id": "711ff29e-9235-4560-ad6f-31c943a447c2",
  //   "user": "277477244611337217,277477244611337217"
  // }
  return {
    appId: "shuyou-miniprogram-h5-production",
    customOption: {
      virtualCharacter: "苏轼",
      stream: true,
      needTts: true,
      needBs: false,
      isConcatGuideQuestion: false,
      guideQuestionNum: 8,
      needEntityAnswer: true,
      needEntity: false,
      separateTts: true,
      needMarkdown: true,
      needVisualization: true,
    },
    id: "b0aeec6b-29b0-4933-a332-66afdbb7670d",
    query: "111",
    sessionId: getDigitalStore().sessionId || Date.now(),
    mentorId: "404",
    userId: null,
    trigger: "text",
    channel: null,
    address: "中国浙江省杭州市西湖区",
    location: "",
    scene: 0,
  };
};

export function processResponseContent(content: string) {
  if (!content.includes("data:")) return content;

  if (!content) return "";

  // 拆分SSE数据块
  const chunks = content.split("data:");
  let result = "";

  for (const chunk of chunks) {
    if (!chunk.trim() || chunk === "[DONE]") continue;

    try {
      const parsed = JSON.parse(chunk);
      if (
        parsed.data &&
        parsed.data.answer &&
        parsed.data.answer.type === "text" &&
        parsed.data.answer.delta
      ) {
        result += parsed.data.answer.delta;
      }
    } catch (error) {
      // 忽略解析错误
    }
  }

  return result;
}

/**
 * 从流内容中提取TTS数据段
 * @param content 流内容
 * @returns TTS数据段数组
 */
export function extractTTSSegments(content: string): Array<TTSData> {
  if (!content || typeof content !== "string") {
    return [];
  }

  const ttsSegments: Array<TTSData> = [];

  // 按行分割内容，每个 data: 块都在独立的行上
  const lines = content
    .split("\n")
    .filter((line) => line?.trim()?.startsWith("data:"));

  for (const line of lines) {
    try {
      // 移除 "data:" 前缀并清理空白字符
      const jsonString = line.replace(/^data:\s*/, "").trim();

      if (jsonString) {
        const jsonData = JSON.parse(jsonString);

        // 检查是否包含 TTS 数据
        if (jsonData.data && jsonData.data.answer && jsonData.data.answer.tts) {
          preloadAudio(jsonData.data.answer.tts);
          ttsSegments.push({
            text: jsonData.data.answer.delta || "",
            url: jsonData.data.answer.tts,
            index: jsonData.data.answer.index || 0,
            messageId: jsonData.data.answer.messageId || "",
            bs: jsonData.data.answer.bs || "",
          });
        }
      }
    } catch (error) {
      // console.error('Error parsing TTS segment:', error, 'Line:', line)
    }
  }

  // 按索引排序
  return ttsSegments.sort((a, b) => a.index - b.index);
}

/**
 * 检查内容是否包含TTS数据
 * @param content 需要检查的内容
 * @returns 是否包含TTS数据
 */
export function hasTTSData(content: string): boolean {
  if (!content || typeof content !== "string") {
    return false;
  }

  return content.includes('"tts":');
}

/**
 * Extracts TTS data from message content
 * @param content The raw message content with TTS data
 * @param messageId The ID of the message
 * @returns Array of TTS data objects
 */
export function extractTTSData(content: string, messageId: string): TTSData[] {
  if (!content || typeof content !== "string") {
    return [];
  }

  // 使用streaming-utils中的extractTTSSegments函数
  const ttsSegments = extractTTSSegments(content);

  // 转换为TTSData格式
  return ttsSegments.map((segment) => ({
    bs: segment.bs,
    text: segment.text,
    url: segment.url,
    index: segment.index,
    messageId,
  }));
}

/** 一些场景下要走问答 */
export function someBusinessCaseToChat(agentData: IAgentDataOutputs) {
  const {mode,routeDetailId} = getStore();
  // case 1: LANDMARK_POETRY 模式，需要检查 location 和 card 数据
  // if (
  //   mode === PageMode.ROUTE_CHARACTER_TRACK &&
  //   agentData?.mode === PageMode.LANDMARK_POETRY &&
  //   agentData?.location &&
  //   agentData?.card
  // ) {
  //   return true;
  // }

  // case 2: ROUTE_CHARACTER_TRACK 模式，需要检查 tour_id 数据
  if (
    mode === PageMode.ROUTE_CHARACTER_TRACK_SINGLE &&
    // agentData?.mode === PageMode.ROUTE_CHARACTER_TRACK_SINGLE &&
    (agentData.tour_id === routeDetailId
      ||
      (agentData?.mode === PageMode.LANDMARK_POETRY &&
        // agentData?.location &&
        // agentData?.card &&
        // agentData?.card===LandmarkPoetryPlaceDetailType.POEM
        agentData?.person
      )
    )
  ) {
    return true;
  }

  return false;
}
